module.exports = __webpack_public_path__ + "img/024.b3876175.png";